module.exports = __webpack_public_path__ + "img/voice-mute.c18eed0.svg";